<template>
	<v-dialog :fullscreen="isMobile" v-if="open" v-model="open" max-width="700px" scrollable>
		<v-card raised>
			<v-card-title>
				<button type="button" class="btn-flat-icon--dark" @click="open=false">
					<v-icon medium flat>fal fa-times</v-icon>
				</button>
			</v-card-title>
			<v-card-text class="pt-0 pl-4 pr-4 event-page__modal-card-text">
				<div>
					<p class="event-page__modal-heading">Guest Requirements</p>
					<v-divider class="mt-3 mb-3"></v-divider>
					<!-- <p class="event-page-content mb-0">This is event is open to:</p> -->
					<choice-field-display class="pb-4" :original="eventRestrictionOptions" :fields="event.restrictions.provisions" :inputs="event.restrictions.inputs"></choice-field-display>
					<p class="event-page-content-light">All guests must be 18+</p>
					<p class="event-page-content" v-if="guestApproval">{{guestApprovalMessage}}</p>
					<p class="event-page-content">If you do not match all the above or have a question about these requirements, please <a @click="contactHostModal=true">contact the host.</a></p>
				</div>
				<div>
					<img class="event-page-flat-logo mb-3 mt-3" src="/static/images/wrkprty-flattened-logo.png" alt="">
				</div>
			</v-card-text>
		</v-card>
	</v-dialog>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { eventRestrictionOptions } from '~/store/util/values'
import ChoiceFieldDisplay from '~/components/ChoiceFieldDisplay'
export default {
	name: 'eventGuestRequirementsModal',
	data() {
		return {
			eventRestrictionOptions: eventRestrictionOptions
		}
	},
	methods: {
		...mapActions(['setModalOpen'])
	},
	computed: {
		...mapGetters(['getModalProp', 'user']),
		open: {
			get() {
				return this.getModalProp('eventGuestRequirementsModal')
			},
			set(val) {
				this.setModalOpen({ prop: 'eventGuestRequirementsModal', value: val })
			}
		},
		contactHostModal: {
			get() {
				return this.getModalProp('eventContactHostModal')
			},
			set(val) {
				this.setModalOpen({ prop: 'eventContactHostModal', value: val })
			}
		},
		event() {
			return this.getModalProp('eventModalEvent')
		},
		isMobile() {
			if (this.$vuetify.breakpoint.name === 'xs') {
				return true
			} else {
				return false
			}
		},
		guestApproval() {
			if (this.event.restrictions.approval === 'all_need_approval') {
				return true
			}
			if (this.event.restrictions.approval === 'level_one') {
				if (this.user.past_events) {
					if (this.user.past_events.length === 0) {
						return true
					}
				}
			}
		},
		guestApprovalMessage() {
			if (this.event.restrictions.approval === 'level_one') {
				return "If you have not attended a wrkprty or if you have received negative feedback you will need to wait for the host's approval before attending this event."
			}
			if (this.event.restrictions.approval === 'all_need_approval') {
				return 'After RSVPing you must wait for the hosts approval before you can attend this event'
			}
		}
	},
	components: {
		ChoiceFieldDisplay
	}
}
</script>
